import { render, staticRenderFns } from "./ColumnOwner.vue?vue&type=template&id=621cda01"
import script from "./ColumnOwner.vue?vue&type=script&lang=ts"
export * from "./ColumnOwner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports